import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import LoginComponent from '@/pages/Login/Login.vue'

export default {
  components: {
    MenuComponent,
    LoginComponent,
    MenuConnexion
  },
  data () {
    return {
      isSessionTimeout: false,
      infoBarMessage: this.$store.state.user.actualiteAccueil ? this.$store.state.user.actualiteAccueil : '',
      urlToCall: this.$store.state.user.user ? this.$store.state.user.user.lienMessagerie : '',
      cafToken: null
    }
  },
  beforeCreate () {
    if (this.$store.state.user.user && this.$store.state.user.user.login) {
      this.$store.dispatch('user/logout', this.$store.state.user.user.login).then(
        () => {
          this.$router.push('accueil')

          this.isSessionTimeout = this.$store.state.sessionTimeout
          this.$store.state.sessionTimeout = false
        }
      )
    } else {
      // Si on est dans un nouvel onglet et qu'on arrive sur l'accueil, on detruit les cookies
      this.$store.dispatch('user/forceLogout').then(
        () => {
          this.$router.push('accueil')

          this.isSessionTimeout = this.$store.state.sessionTimeout
          this.$store.state.sessionTimeout = false
        }
      )
    }

    // Recherche du message à afficher dans l'infoBar
    if (!this.$store.state.user.actualiteAccueil) {
      this.$store.dispatch('user/infoAccueil').then(
        response => {
          this.infoBarMessage = response
        }
      )
    }
  },
  mounted () {
    if (this.urlToCall && this.$store.state.user.user.connectedToMessagerie) {
      this.disconnectMessagerie()
    }
  },
  methods: {
    async disconnectMessagerie () {
      await this.$store.dispatch('user/getTokenForMessagerie', this.$store.state.user.user.login).then(
        response => {
          this.cafToken = response
        },
        () => {
        }
      )

      // On se deconnecte aussi de la messagerie
      // eslint-disable-next-line
      $('#buttonMessagerieLogout').click()

      this.urlToCall = null
      this.cafToken = null

      // On place un boolean dans le store pour deconnecter le user
      this.$store.dispatch('user/userConnectionToMessagerie', false)

      // reload si le user a cliquer se deconnecter en etant sur la messagerie pour remettre le scroll sur le site
      location.reload()
    }
  }
}
